import { GenericAbortSignal } from 'axios';

import Classification, { ClassificationApiName, ClassificationOptions } from 'models/Classification';
import { Paginated } from 'models/Paginated';
import http from 'services/http';

import { BaseIndexQueryParams } from './types';

export const clientClassificationsQueryKeys = {
  index: (params: Record<string, any> = {}) => ['client_classifications', 'index', params],
};

type IndexParams = BaseIndexQueryParams & {
  classificationType: ClassificationApiName;
};

export type AdditionalMeta = {
  healthPlansLastUpdated: { date: string; userName: string };
};

export async function indexClientClassifications(params: IndexParams, signal: GenericAbortSignal) {
  return http
    .get<Paginated<ClassificationOptions, AdditionalMeta>>(`client_classifications`, { params, signal })
    .then((res) => ({
      ...res.data,
      data: res.data.data.map((x) => new Classification(x)),
    }));
}

type UpdateClientClassificationsParams = {
  classificationType: ClassificationApiName;
  classificationIds: string[];
};

export async function updateClientClassifications(params: UpdateClientClassificationsParams) {
  return http.put<ClassificationOptions>(`client_classifications`, { ...params }).then((res) => {
    return {
      ...res.data,
    };
  });
}

type DeleteClientClassificationParams = {
  classificationType: ClassificationApiName;
  classificationId: string;
};

export async function deleteClientClassification(params: DeleteClientClassificationParams) {
  return http.delete<ClassificationOptions>(`client_classifications`, { params }).then((res) => {
    return {
      ...res.data,
    };
  });
}
